// Timestamp relativo localizado (hace 5 min, ayer, hace 3 d…). Recibe la
// función `t` de i18next para respetar el idioma activo. Para fechas de más
// de una semana cae al formato de fecha local del navegador.
export default function timeAgo(date, t) {
  if (!date) return '';
  const d = new Date(date);
  const diffMs = Date.now() - d.getTime();
  const min = Math.floor(diffMs / 60000);
  if (min < 1) return t('messages.now');
  if (min < 60) return t('messages.min_ago', { count: min });
  const hours = Math.floor(min / 60);
  if (hours < 24) return t('messages.hour_ago', { count: hours });
  const days = Math.floor(hours / 24);
  if (days === 1) return t('messages.yesterday');
  if (days < 7) return t('messages.days_ago', { count: days });
  return d.toLocaleDateString();
}
